import React, { useEffect, useContext, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PropTypes from 'prop-types';
// import { Acl } from 'modules/common/components/Acl';
// import { getJson } from 'session';
import { connect } from 'react-redux';
import _, { isEmpty } from 'lodash';
// import defaultPhoto from 'assets/img/image-placeholder.jpg';
import { ucwords, numberWithCommas } from 'helper';
import Img from 'modules/common/components/Img';
import { ModalContext } from 'App';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import InputReactSelect from 'modules/common/components/InputReactSelect';
import OfficeUpdateModal from './components/OfficeUpdateModal';
import UpdateRemarksModal from './components/UpdateRemarksModal';

import * as c from '../../constant';
import * as actions from '../../actions';

const statusOptions = ['PENDING', 'APPROVED', 'REJECTED'];

function EndorsingOffices({
  data,
  getEndorsingOfficesList,
  endorsingOfficesList,
  endorsingOfficeApprove,
  getItem,
  endorsingOfficeReject,
  endorsingOfficesStatistics,
  handleEndorsingOffice,
  getEndorsingOffices,
  endorsingOffices,
}) {
  const setModal = useContext(ModalContext);
  // const permissions = getJson('permissions');
  const [filter, setFilter] = React.useState({});
  const [tab, setTab] = React.useState(0);

  const endorsingOfficeOptions = useMemo(() => {
    if (!endorsingOffices || isEmpty(endorsingOffices)) return [];
    return endorsingOffices.map((item) => ({
      value: _.get(item, 'id'),
      label: _.get(item, 'attributes.name'),
    }));
  }, [endorsingOffices]);

  useEffect(() => {
    if (!data?.id) return;
    getEndorsingOffices(data.id);
    getEndorsingOfficesList(data.id, filter);
  }, [data.id, filter]);

  const handleOfficeUpdate = (dataInfo) => (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <OfficeUpdateModal
          data={dataInfo}
          id={data.id}
          status={_.get(data, 'attributes.transaction_status')}
          handleEndorsingOffice={handleEndorsingOffice}
        />
      ),
      title: 'Update Endorsing Office',
      modalSize: 'modal-md',
    });
  };

  const handleOfficeApprove = (dataInfo) => (e) => {
    e.preventDefault();
    setModal({ isOpen: false });

    ConfirmAlert(
      `Are you sure you want to approve?`,
      (remarks) => {
        endorsingOfficeApprove(
          data.id,
          {
            other_fee_id: _.get(dataInfo, 'other_fee_id'),
            endorsing_office_id: _.get(dataInfo, 'endorsing_office.id'),
            remarks,
          },
          () => {
            getItem(data.id);
            getEndorsingOfficesList(data.id);
            handleEndorsingOffice(e);
          }
        );
      },
      () => {
        handleEndorsingOffice(e);
      },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true,
      false
    );
  };

  const handleOfficeReject = (dataInfo) => (e) => {
    e.preventDefault();
    setModal({ isOpen: false });

    ConfirmAlert(
      `Are you sure you want to reject this transaction?`,
      (remarks) => {
        endorsingOfficeReject(
          data.id,
          {
            remarks,
            other_fee_id: _.get(dataInfo, 'other_fee_id'),
            endorsing_office_id: _.get(dataInfo, 'endorsing_office.id'),
          },
          () => {
            getItem(data.id);
            getEndorsingOfficesList(data.id);
            handleEndorsingOffice(e);
          }
        );
      },
      () => {
        handleEndorsingOffice(e);
      },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleRemarksUpdate = (dataInfo) => (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <UpdateRemarksModal
          data={dataInfo}
          id={data.id}
          handleEndorsingOffice={handleEndorsingOffice}
        />
      ),
      title: `Update Remarks`,
      modalSize: 'modal-md',
    });
  };

  const spanGap = 8;

  const onChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => {
      return { ...prev, [name]: value };
    });
  };

  return (
    <div className="p-3">
      <h3 className="font-weight-bold">Statistics</h3>
      <div className="d-flex flex-row justify-content-start align-items-center mb-3">
        {Object.entries(endorsingOfficesStatistics ?? {}).map((item) => {
          return (
            <div
              className="card card-body p-3 m-3"
              key={`bpls_endorsing_offices_${item[0]}`}
            >
              <div className="">
                <h3 className="text-dark font-weight-bold" width="180">
                  {ucwords(item[0].replace(/_/g, ' ') || '')}
                </h3>
                <div className="d-flex flex-column">
                  <div className="d-flex justify-content-between">
                    <div>Approved</div>
                    <div>{item[1].approved || 0}</div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>Pending</div>
                    <div>{item[1].pending || 0}</div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>Rejected</div>
                    <div>{item[1].rejected || 0}</div>
                  </div>
                  <div className="d-flex justify-content-between mt-3">
                    <h4 className="text-dark font-weight-bold">Total</h4>
                    <h4 className="text-dark font-weight-bold">
                      {item[1].total || 0}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="row mb-3" style={{ gap: '10px' }}>
        <div className="col-md-4 form-group">
          <label htmlFor="endorsing_office_id" className="full-label mb-1">
            Endorsing Office
          </label>
          <InputReactSelect
            name="endorsing_office_id"
            value={
              endorsingOfficeOptions.find(
                (item) => item.value === filter.endorsing_office_id
              ) || ''
            }
            onChange={onChange}
            options={endorsingOfficeOptions}
            placeholder="Select Endorsing Office"
            isClearable
            isSearchable
          />
        </div>
        <div className="col-md-4 form-group">
          <label htmlFor="status" className="full-label mb-1">
            Status
          </label>
          <InputReactSelect
            name="status"
            value={
              filter.status
                ? { label: filter.status, value: filter.status }
                : ''
            }
            onChange={onChange}
            options={statusOptions.map((item) => ({
              value: item,
              label: item,
            }))}
            placeholder="Select Status"
            isClearable
            isSearchable
          />
        </div>
      </div>

      <Tabs selectedIndex={tab} onSelect={(index) => setTab(index)}>
        <div className="row">
          <div className="col">
            <TabList style={{ overflow: 'auto', alignItems: 'flex-end' }}>
              {endorsingOfficesList.map((item) => (
                <Tab
                  key={_.get(item, 'fee_code')}
                  style={{ flex: 'none', textAlign: 'right' }}
                >
                  {_.get(item, 'fee_description')}
                </Tab>
              ))}
            </TabList>
          </div>
        </div>
        {endorsingOfficesList.length > 0 ? (
          endorsingOfficesList.map((item, index) => {
            return (
              /* eslint-disable-next-line */
              <TabPanel key={`detail-${index}`}>
                <div className="p-3">
                  <div className='text-right mb-3'>
                    <button
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary ml-2 font-weight-bold"
                      type="button"
                      onClick={handleRemarksUpdate(item)}
                    >
                      Remarks
                    </button>
                    {_.get(item, 'is_editable') === 1 &&
                    _.get(item, 'status') === 'PENDING' ? (
                      <button
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary ml-2 font-weight-bold"
                        type="button"
                        onClick={handleOfficeUpdate(item)}
                      >
                        Update
                      </button>
                    ) : (
                      ''
                    )}
                    {['ISSUED'].indexOf(
                        _.get(data, 'attributes.transaction_status')
                      ) > -1 && (
                        <button
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary ml-2 font-weight-bold"
                          type="button"
                          onClick={handleOfficeUpdate(item)}
                        >
                          Update
                        </button>
                      )}
                    {_.get(item, 'is_editable') === 1 &&
                      _.get(item, 'status') === 'APPROVED' &&
                      _.get(data, 'attributes.transaction_status') ===
                        'FOR PRINTING' && (
                        <button
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary ml-2 font-weight-bold"
                          type="button"
                          onClick={handleOfficeUpdate(item)}
                        >
                          Update
                        </button>
                      )}
                    {_.get(item, 'is_editable') === 1 &&
                    !_.get(item, 'assessed_by') &&
                    _.get(item, 'status') === 'PENDING' ? (
                      <>
                        <button
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary ml-2 font-weight-bold"
                          type="button"
                          onClick={handleOfficeApprove(item)}
                        >
                          Approve
                        </button>
                        <button
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary ml-2 font-weight-bold"
                          type="button"
                          onClick={handleOfficeReject(item)}
                        >
                          Reject
                        </button>
                      </>
                    ) : (
                      ''
                    )}
                  </div>
                  <table className="transaction-table table table-borderless table-sm text-break">
                    <tbody>
                      <tr>
                        <td className="text-dark" colSpan={spanGap}>
                          Name of Endorsing Office
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(item, 'endorsing_office.name') || '-'}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" colSpan={spanGap}>
                          Amount
                        </td>
                        <td colSpan={4}>
                          <b>
                            {'\u20B1'}&nbsp;
                            {numberWithCommas(_.get(item, 'endorsed_amount')).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ) || 0.00}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" colSpan={spanGap}>
                          Status
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(item, 'status') || '-'}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" colSpan={spanGap}>
                          Remarks
                        </td>
                        <td colSpan={4} className=''>
                          <b>{_.get(item, 'remarks') || '-'}</b>
                        </td>
                      </tr>
                      {_.get(item, 'is_approved') === 1 ? (
                        <>
                          <tr>
                            <td className="text-dark" colSpan={spanGap}>
                              Approved by
                            </td>
                            <td colSpan={4}>
                              <b>{_.get(item, 'approved_by') || '-'}</b>
                            </td>
                          </tr>
                          <tr>
                            <td className="text-dark" colSpan={spanGap}>
                              Approved at
                            </td>
                            <td colSpan={4}>
                              <b>{_.get(item, 'approved_at') || '-'}</b>
                            </td>
                          </tr>
                        </>
                      ) : (
                        ''
                      )}
                      {_.get(item, 'is_approved') === 0 &&
                      !_.isEmpty(_.get(item, 'rejected_by')) ? (
                        <>
                          <tr>
                            <td className="text-dark" colSpan={spanGap}>
                              Rejected by
                            </td>
                            <td colSpan={4}>
                              <b>{_.get(item, 'rejected_by') || '-'}</b>
                            </td>
                          </tr>
                          <tr>
                            <td className="text-dark" colSpan={spanGap}>
                              Rejected at
                            </td>
                            <td colSpan={4}>
                              <b>{_.get(item, 'rejected_at') || '-'}</b>
                            </td>
                          </tr>
                        </>
                      ) : (
                        ''
                      )}
                      <tr>
                        <td className="text-dark" colSpan={spanGap}>
                          Document Number
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(item, 'document_number') || '-'}</b>
                        </td>
                      </tr>
                      <tr className="p-3">
                        <td className="text-dark" colSpan={spanGap}>
                          Document
                        </td>
                        <td>
                          {/*  */}
                          {_.get(item, 'document_url', '')?.includes('pdf') ? (
                            <iframe
                              title="Birth certificate requirements"
                              style={{ width: '100%', height: '500px' }}
                              className="img img-fluid"
                              alt={`documents_${_.get(item, 'document_url')}`}
                              src={_.get(item, 'document_url')}
                              // alt={defaultPhoto}
                            />
                          ) : (
                            <Img
                              key={item.id}
                              src={_.get(item, 'document_url')}
                              className="shadow-md"
                              role="presentation"
                              // defaultSrc={defaultPhoto}
                              width="30%"
                              alt=""
                            />
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </TabPanel>
            );
          })
        ) : (
          <div className="d-flex align-items-center justify-content-center h-100">
            <div className="text-center mx-auto py-4">
              <p className="emp-title mb-0">No Item Found</p>
            </div>
          </div>
        )}
      </Tabs>

      <div className="d-flex justify-content-center mt-3">
        <button
          className="btn btn-primary cms-bg-color-primary cms-outline-primary ml-2 font-weight-bold"
          type="button"
          onClick={() => setModal({ isOpen: false })}
        >
          Close
        </button>
      </div>
    </div>
  );
}

EndorsingOffices.defaultProps = {
  data: '',
};

EndorsingOffices.propTypes = {
  data: PropTypes.instanceOf(Object),
  getEndorsingOfficesList: PropTypes.instanceOf(Function).isRequired,
  endorsingOfficesList: PropTypes.instanceOf(Array).isRequired,
  endorsingOfficeApprove: PropTypes.instanceOf(Function).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  endorsingOfficeReject: PropTypes.instanceOf(Function).isRequired,
  endorsingOfficesStatistics: PropTypes.instanceOf(Object).isRequired,
  handleEndorsingOffice: PropTypes.instanceOf(Function).isRequired,
  getEndorsingOffices: PropTypes.instanceOf(Function).isRequired,
  endorsingOffices: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => {
  return {
    endorsingOfficesList:
      _.get(api, `${c.GET_ENDORSING_OFFICES_LIST}.list`) || [],
    endorsingOfficesStatistics:
      _.get(api, `${c.GET_ENDORSING_OFFICES_LIST}.res.statistics`) || {},
    endorsingOffices: _.get(api, `${c.GET_ENDORSING_OFFICES}.list`) || [],
  };
};

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(EndorsingOffices);
